import { Routes, Route, Navigate } from "react-router-dom";
import { lazy, Suspense } from "react";
import { ProtectedRoute } from "./components/auth/ProtectedRoute";
import { RoleRoute } from "./components/auth/RoleRoute";
import { AdminLayout } from "./layouts/AdminLayout";
import { ClienteLayout } from "./layouts/ClienteLayout";
import { AseguradoraLayout } from "./layouts/AseguradoraLayout";
import { LoginPage } from "./pages/LoginPage";
import { RegisterPage } from "./pages/RegisterPage";
import { RecuperarPasswordPage } from "./pages/RecuperarPasswordPage";
import { ResetearPasswordPage } from "./pages/ResetearPasswordPage";
import { UnauthorizedPage } from "./pages/UnauthorizedPage";
import { PagoOkPage } from "./pages/pago/PagoOkPage";
import { PagoKoPage } from "./pages/pago/PagoKoPage";
import { ClientesPage } from "./pages/admin/ClientesPage";
import { CrmPage } from "./pages/admin/CrmPage";
import { ModalidadesPage } from "./pages/admin/ModalidadesPage";
import { SegurosPage } from "./pages/admin/SegurosPage";
import { DocumentosPage } from "./pages/admin/DocumentosPage";
import { AnunciosPage } from "./pages/admin/AnunciosPage";
import { InformesPage } from "./pages/admin/InformesPage";
import { CobrosMitPage } from "./pages/admin/CobrosMitPage";
import { RecibosPage } from "./pages/admin/RecibosPage";
import { AseguradorasPage } from "./pages/admin/AseguradorasPage";
import { CertificadoPlantillaPage } from "./pages/admin/CertificadoPlantillaPage";
import { MisSegurosPage } from "./pages/cliente/MisSegurosPage";
import { ClienteDashboardPage } from "./pages/cliente/ClienteDashboardPage";
import { MisModalidadesPage } from "./pages/cliente/MisModalidadesPage";
import { NuevoSeguroPage } from "./pages/cliente/NuevoSeguroPage";
import { DocumentosClientePage } from "./pages/cliente/DocumentosPage";
import { CuentaPage } from "./pages/cliente/CuentaPage";
import { CertificadosPage } from "./pages/aseguradora/CertificadosPage";
import { AseguradoraApiPage } from "./pages/aseguradora/ApiPage";
import { MisQRPage } from "./pages/cliente/MisQRPage";
import { ConfiguracionPage } from "./pages/cliente/ConfiguracionPage";
import { TarjetasPage } from "./pages/cliente/TarjetasPage";
import { TarjetasOkPage } from "./pages/cliente/TarjetasOkPage";
import { TarjetasKoPage } from "./pages/cliente/TarjetasKoPage";
import { ContratarPage } from "./pages/public/ContratarPage";
import { ContratarGraciasPage } from "./pages/public/ContratarGraciasPage";
import { ContratarErrorPage } from "./pages/public/ContratarErrorPage";

const PilotoGridEditorPage = lazy(() => import("./pages/cliente/PilotoGridEditorPage"));
const MisPilotosPage = lazy(() =>
  import("./pages/cliente/MisPilotosPage").then((m) => ({ default: m.MisPilotosPage }))
);
const MisRecibosPage = lazy(() =>
  import("./pages/cliente/MisRecibosPage").then((m) => ({ default: m.MisRecibosPage }))
);
const DashboardPage = lazy(() =>
  import("./pages/admin/DashboardPage").then((m) => ({ default: m.DashboardPage }))
);
const DashboardDetallePage = lazy(() =>
  import("./pages/admin/DashboardDetallePage").then((m) => ({ default: m.DashboardDetallePage }))
);

function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route path="/recuperar-password" element={<RecuperarPasswordPage />} />
      <Route path="/resetear-password" element={<ResetearPasswordPage />} />
      <Route path="/unauthorized" element={<UnauthorizedPage />} />
      <Route path="/pago/ok" element={<PagoOkPage />} />
      <Route path="/pago/ko" element={<PagoKoPage />} />
      <Route path="/contratar/gracias" element={<ContratarGraciasPage />} />
      <Route path="/contratar/error" element={<ContratarErrorPage />} />
      <Route path="/contratar/:token" element={<ContratarPage />} />

      <Route element={<ProtectedRoute />}>
        <Route
          element={
            <RoleRoute roles={["admin", "director_comercial", "comercial"]} />
          }
        >
          <Route element={<AdminLayout />}>
            <Route path="/admin/crm" element={<CrmPage />} />
            <Route element={<RoleRoute roles={["admin"]} />}>
              <Route
                path="/admin"
                element={
                  <Suspense fallback={<div className="p-8 text-gray-500">Cargando dashboard...</div>}>
                    <DashboardPage />
                  </Suspense>
                }
              />
              <Route path="/admin/clientes" element={<ClientesPage />} />
              <Route path="/admin/dashboard/detalle" element={<Suspense fallback={<div className="p-8 text-gray-500">Cargando desglose...</div>}><DashboardDetallePage /></Suspense>} />
              <Route path="/admin/modalidades" element={<ModalidadesPage />} />
              <Route path="/admin/seguros" element={<SegurosPage />} />
              <Route path="/admin/documentos" element={<DocumentosPage />} />
              <Route path="/admin/certificado-plantilla" element={<CertificadoPlantillaPage />} />
              <Route path="/admin/anuncios" element={<AnunciosPage />} />
              <Route path="/admin/informes" element={<InformesPage />} />
              <Route path="/admin/cobros-mit" element={<CobrosMitPage />} />
              <Route path="/admin/recibos" element={<RecibosPage />} />
              <Route path="/admin/aseguradoras" element={<AseguradorasPage />} />
            </Route>
          </Route>
        </Route>
      </Route>

      <Route element={<ProtectedRoute />}>
        <Route element={<RoleRoute roles={["cliente", "admin"]} />}>
          <Route element={<ClienteLayout />}>
            <Route path="/dashboard" element={<ClienteDashboardPage />} />
            <Route path="/dashboard/seguros" element={<MisSegurosPage />} />
            <Route
              path="/dashboard/pilotos"
              element={
                <Suspense fallback={<div className="p-8 text-gray-500">Cargando...</div>}>
                  <MisPilotosPage />
                </Suspense>
              }
            />
            <Route
              path="/dashboard/recibos"
              element={
                <Suspense fallback={<div className="p-8 text-gray-500">Cargando...</div>}>
                  <MisRecibosPage />
                </Suspense>
              }
            />
            <Route path="/dashboard/modalidades" element={<MisModalidadesPage />} />
            <Route path="/dashboard/nuevo-seguro" element={<NuevoSeguroPage />} />
            <Route path="/dashboard/seguros/:id/editar" element={<NuevoSeguroPage />} />
            <Route path="/dashboard/documentos" element={<DocumentosClientePage />} />
            <Route path="/dashboard/qr" element={<MisQRPage />} />
            <Route path="/dashboard/configuracion" element={<ConfiguracionPage />} />
            <Route path="/dashboard/tarjetas" element={<TarjetasPage />} />
            <Route path="/dashboard/tarjetas/ok" element={<TarjetasOkPage />} />
            <Route path="/dashboard/tarjetas/ko" element={<TarjetasKoPage />} />
            <Route path="/dashboard/cuenta" element={<CuentaPage />} />
            <Route
              path="/dashboard/seguros/:id/editor"
              element={
                <Suspense fallback={<div className="p-8 text-gray-500">Cargando editor...</div>}>
                  <PilotoGridEditorPage />
                </Suspense>
              }
            />
          </Route>
        </Route>
      </Route>

      <Route element={<ProtectedRoute />}>
        <Route element={<RoleRoute roles={["aseguradora", "admin"]} />}>
          <Route element={<AseguradoraLayout />}>
            <Route path="/aseguradora" element={<CertificadosPage />} />
            <Route path="/aseguradora/api" element={<AseguradoraApiPage />} />
          </Route>
        </Route>
      </Route>

      <Route path="/" element={<Navigate to="/login" replace />} />
      <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>
  );
}

export default App;
